import { Button, Form, Modal, Card, Row, Col, InputGroup, Table, FloatingLabel } from 'react-bootstrap';
import { FaInfoCircle } from 'react-icons/fa';
import InfoTooltip from '../../core/ToolTip';
import React, { useEffect, useState } from 'react';
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { blockInvalidChar } from '../Util';
import { FaEdit, FaTrash } from 'react-icons/fa';

const PerformanceDataModal = ({ show, onClose, onSave, dataItem }) => {
    const data = {
        qualitative: {
            programCategory: "",
            programType: "",
            programName: "",
            programDate: "",
            programObjective: "",
            objectiveMet: "",
            missionRelated: "",
            financialSustainability: "",
            communityEngagement: "",
            programEntail: "",
            programPartnersList: "",
            otherNotes: ""
        },
        quantitative: {
            targetAudiences: "",
            onsiteOrOffsite: "",
            virtualOrInPerson: "",
            attendance: "",
            countyHeld: "",
            freeOrDiscounted: ""
        },
        fiscal: [],
        netRevenue: 0

    }

    const [isVirtual, setVirtual] = useState(false);

    const [showCalendar, setShowCalendar] = useState(false);
    const handleDateChange = (selectedDate) => {
        performancdDataForm.setFieldValue('qualitative.programDate', selectedDate.toISOString().split('T')[0]);
    }
    const performanceDataSchema = Yup.object({
        qualitative: Yup.object({
            programCategory: Yup.string().required('Program Category is required'),
            programType: Yup.string().required('Program Type is required'),
            programName: Yup.string().required('Program Name is required'),
            programDate: Yup.date().required('Program Date is required'),
            programObjective: Yup.string().required('Program Objective  is required'),
            objectiveMet: Yup.string().required('ObjectiveMet  is required'),
            missionRelated: Yup.string().required('Mission Related is required'),
            financialSustainability: Yup.string().required('Financial Sustainability is required'),
            communityEngagement: Yup.string().required('Community Engagement is required'),
            programEntail: Yup.string().required('Program entail is required'),
            programPartnersList: Yup.string().required('Program partners list is required'),

        }),
        quantitative: Yup.object({
            targetAudiences: Yup.string().required('Target Audiences is required'),
            virtualOrInPerson: Yup.string().required('virtualOrInPerson is required'),
            attendance: Yup.string().required('attendance is required'),
            countyHeld: Yup.string().required('Location of Attendees is required'),
        }),
        fiscal: Yup.array().of(
            Yup.object().shape({
                revenue: Yup.string().required(),
                expenses: Yup.string().required(),
                projectedBudget: Yup.number().required()
            })
        ).min(1, 'At least one fiscal data is required')
    })


    const performancdDataForm = useFormik({
        initialValues: data,
        validationSchema: performanceDataSchema,
        onClick: (values) => {

        }
    });
    const handleReset = () => {
        performancdDataForm.resetForm();
    }
    const handleData = () => {
        performancdDataForm.validateForm().then(() => {
            if (Object.keys(performancdDataForm.errors).length === 0) {
                // If there are no validation errors, add the record
                console.log("Adding record:", performancdDataForm.values);
                Object.values(performancdDataForm.values.fiscal).forEach(entry => entry.projectedBudget)
                const data = performancdDataForm.values.fiscal;
                console.log(`fiscal :` + data);
                const sum = data.reduce((accumulator, currentValue) => accumulator + parseFloat(currentValue.projectedBudget), 0);
                console.log(`net revenue :${sum}`);
                performancdDataForm.setFieldValue('netRevenue', sum);
                console.log(`performancdDataForm.values : ${performancdDataForm.values}`);
                onSave(performancdDataForm.values);
                performancdDataForm.resetForm();
                onClose();
            } else {
                console.log('error')
                Object.values(performancdDataForm.errors).map(err => console.error(err));
            }
        });
    };

    useEffect(() => {
        console.log('onload Performance Data modal');
        if (show && dataItem) {
            console.log(dataItem);

            performancdDataForm.setValues({
                qualitative: {
                    programCategory: dataItem.programCategory,
                    programType: dataItem.programType,
                    programName: dataItem.programName,
                    programDate: dataItem.programDate,
                    programObjective: dataItem.programObjective,
                    objectiveMet: dataItem.objectiveMet,
                    missionRelated: dataItem.missionRelated,
                    financialSustainability: dataItem.financialSustainability,
                    communityEngagement: dataItem.communityEngagement,
                    programEntail: dataItem.programEntail,
                    programPartnersList: dataItem.programPartnersList,
                    otherNotes: dataItem.otherNotes
                },
                quantitative: {
                    targetAudiences: "",
                    onsiteOrOffsite: "",
                    virtualOrInPerson: "",
                    attendance: "",
                    countyHeld: "",
                    freeOrDiscounted: ""
                },
                fiscal: [],
                netRevenue: 0,

            });

        } else {
            console.log('else onload');
            performancdDataForm.resetForm();
        }
    }, [show, dataItem]);

    const [fiscalData, setFiscalData] = useState([]);
    const fiscal = {
        revenue: "",
        expenses: "",
        projectedBudget: ""
    }
    const fiscalSchema = Yup.object({
        revenue: Yup.string().required('Revenue is required'),
        expenses: Yup.string().required('Expenses is required'),
        projectedBudget: Yup.number().required('Proposed/Projected budget is required')
            .positive('Number must be positive')
            .integer('Decimal values are not allowed')
    });

    const fiscalForm = useFormik({
        initialValues: fiscal,
        initialTouched: {
            revenue: true,
            expenses: true,
            projectedBudget: true,
        },
        validationSchema: fiscalSchema,
        onClick: (values) => {

        }
    });
    const handleFiscalRecord = () => {
        console.log('add clicked : ' + fiscalForm.touched.revenue);
        fiscalForm.validateForm().then(() => {
            console.log('errors:' + fiscalForm.errors);
            if (Object.keys(fiscalForm.errors).length === 0) {
                // If there are no validation errors, add the record
                console.log("Adding record:", fiscalForm.values);
                setFiscalData((prevData) => [...prevData, fiscalForm.values]);
                performancdDataForm.setFieldValue('fiscal', [...performancdDataForm.values.fiscal, fiscalForm.values]);
                fiscalForm.resetForm(); // Optionally reset the form after adding a record
                fiscalForm.values = fiscal;
            } else {
                console.log('Adding Fiscal data error')
            }
        });
    };

    return (
        <>
            <Modal show={show} onHide={onClose} size='xl'>
                <Form >
                    <Modal.Header closeButton>
                        <Modal.Title>Performance Data</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>

                        <Card>
                            <Card.Title>Qualitative Data</Card.Title>
                            <Card.Body>
                                <Row className="mb-0 main-content" >
                                    <Form.Group as={Col} controlId="programCategory">
                                        <FloatingLabel label="Program Category">
                                            <Form.Select defaultValue="" name="qualitative.programCategory" value={performancdDataForm.values.qualitative.programCategory}
                                                onChange={performancdDataForm.handleChange}
                                                onBlur={performancdDataForm.handleBlur}
                                                isInvalid={performancdDataForm.touched.qualitative?.programCategory && performancdDataForm.errors.qualitative?.programCategory}>
                                                <option value=''>Select</option>
                                                <option>Special Event</option>
                                                <option>Recurring interpretive Program</option>
                                                <option>School Program</option>
                                                <option>Educational outreach Program</option>
                                                <option>Community Friend raising Program/Appearance</option>
                                                <option>Training Program for outside groups</option>
                                                <option>Fundraiser</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                        <Form.Control.Feedback type="invalid">
                                            {performancdDataForm.touched.qualitative?.programCategory && performancdDataForm.errors.qualitative?.programCategory}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="programType">
                                        <FloatingLabel label="Program Type">
                                            <Form.Select defaultValue="Choose..." name="qualitative.programType" value={performancdDataForm.values.qualitative.programType}
                                                onChange={performancdDataForm.handleChange}
                                                onBlur={performancdDataForm.handleBlur}
                                                isInvalid={performancdDataForm.touched.qualitative?.programType && performancdDataForm.errors.qualitative?.programType}>
                                                <option value=''>Select</option>
                                                <option>New</option>
                                                <option>Recurring Program</option>
                                            </Form.Select>
                                        </FloatingLabel>
                                        <Form.Control.Feedback type="invalid">
                                            {performancdDataForm.touched.qualitative?.programType && performancdDataForm.errors.qualitative?.programType}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="programName">
                                        <FloatingLabel label="Name of Program ">
                                            <Form.Control name='qualitative.programName' value={performancdDataForm.values.qualitative?.programName}
                                                onChange={performancdDataForm.handleChange}
                                                onBlur={performancdDataForm.handleBlur}
                                                isInvalid={performancdDataForm.touched.qualitative?.programName && performancdDataForm.errors.qualitative?.programName} />
                                        </FloatingLabel>
                                        <Form.Control.Feedback type="invalid">
                                            {performancdDataForm.touched.qualitative?.programName && performancdDataForm.errors.qualitative?.programName}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="programDate">

                                        <FloatingLabel label="Date of Program">

                                            <Form.Control name='qualitative.programDate' value={performancdDataForm.values.qualitative?.programDate}
                                                onClick={() => setShowCalendar(!showCalendar)}
                                                onChange={performancdDataForm.handleChange}
                                                onBlur={performancdDataForm.handleBlur}
                                                isInvalid={performancdDataForm.touched.qualitative?.programDate && performancdDataForm.errors.qualitative?.programDate} />
                                            {showCalendar && <Calendar onChange={handleDateChange} value={performancdDataForm.values.qualitative?.programDate} onClickDay={() => setShowCalendar(false)} />}
                                        </FloatingLabel>
                                        <Form.Control.Feedback type="invalid">
                                            {performancdDataForm.touched.qualitative?.programDate && performancdDataForm.errors.qualitative?.programDate}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                </Row>

                                <Row className="mb-0 main-content" >
                                    <Col>
                                        <Card>
                                            <Card.Body>

                                                <Row className="mb-0 main-content" >
                                                    <Form.Group as={Col} controlId="programObjective">
                                                        <FloatingLabel label="Program Objectives">
                                                            <Form.Control as="textarea" name="qualitative.programObjective" value={performancdDataForm.values.qualitative?.programObjective}
                                                                onChange={performancdDataForm.handleChange}
                                                                onBlur={performancdDataForm.handleBlur}
                                                                isInvalid={performancdDataForm.touched.qualitative?.programObjective && performancdDataForm.errors.qualitative?.programObjective} />
                                                        </FloatingLabel>
                                                        <Form.Control.Feedback type="invalid">
                                                            {performancdDataForm.touched.qualitative?.programObjective && performancdDataForm.errors.qualitative?.programObjective}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="objectMet">
                                                        <FloatingLabel label="Objectives met? ">

                                                            <Form.Control as="textarea" name="qualitative.objectiveMet" value={performancdDataForm.values.qualitative?.objectiveMet}
                                                                onChange={performancdDataForm.handleChange}
                                                                onBlur={performancdDataForm.handleBlur}
                                                                isInvalid={performancdDataForm.touched.qualitative?.objectiveMet && performancdDataForm.errors.qualitative?.objectiveMet} />
                                                        </FloatingLabel>
                                                        <Form.Control.Feedback type="invalid">
                                                            {performancdDataForm.touched.qualitative?.objectiveMet && performancdDataForm.errors.qualitative?.objectiveMet}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col>
                                        <Card >
                                            <Card.Body>
                                                <Row className='mb-0 main-content'>
                                                    <Form.Group as={Col} controlId="missionRelated">

                                                        <FloatingLabel label="Mission-related">
                                                            <Form.Select name="qualitative.missionRelated" value={performancdDataForm.values.qualitative?.missionRelated}
                                                                onChange={performancdDataForm.handleChange}
                                                                onBlur={performancdDataForm.handleBlur}
                                                                isInvalid={performancdDataForm.touched.qualitative?.missionRelated && performancdDataForm.errors.qualitative?.missionRelated} >
                                                                <option value=''>Select</option>
                                                                <option>High</option>
                                                                <option>Medium</option>
                                                                <option>Low</option>
                                                            </Form.Select>
                                                        </FloatingLabel>
                                                        <Form.Control.Feedback type="invalid">
                                                            {performancdDataForm.touched.qualitative?.missionRelated && performancdDataForm.errors.qualitative?.missionRelated}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="financialSustainability">
                                                        <FloatingLabel label="Financial Sustainability" >
                                                            <Form.Select name="qualitative.financialSustainability" value={performancdDataForm.values.qualitative?.financialSustainability}
                                                                onChange={performancdDataForm.handleChange}
                                                                onBlur={performancdDataForm.handleBlur}
                                                                isInvalid={performancdDataForm.touched.qualitative?.financialSustainability && performancdDataForm.errors.qualitative?.financialSustainability} >
                                                                <option value=''>Select</option>
                                                                <option>High</option>
                                                                <option>Medium</option>
                                                                <option>Low</option>
                                                            </Form.Select>
                                                        </FloatingLabel>
                                                        <Form.Control.Feedback type="invalid">
                                                            {performancdDataForm.touched.qualitative?.financialSustainability && performancdDataForm.errors.qualitative?.financialSustainability}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                    <Form.Group as={Col} controlId="communityEngagement">
                                                        <FloatingLabel label="Community Engagement">
                                                            <Form.Select name="qualitative.communityEngagement" value={performancdDataForm.values.qualitative?.communityEngagement}
                                                                onChange={performancdDataForm.handleChange}
                                                                onBlur={performancdDataForm.handleBlur}
                                                                isInvalid={performancdDataForm.touched.qualitative?.communityEngagement && performancdDataForm.errors.qualitative?.communityEngagement} >
                                                                <option value=''>Select</option>
                                                                <option>High</option>
                                                                <option>Medium</option>
                                                                <option>Low</option>
                                                            </Form.Select>
                                                        </FloatingLabel>
                                                        <Form.Control.Feedback type="invalid">
                                                            {performancdDataForm.touched.qualitative?.communityEngagement && performancdDataForm.errors.qualitative?.communityEngagement}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </Row>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                                <Row className="mb-0 main-content" >
                                    <Form.Group as={Col} controlId="programEntail">
                                        <FloatingLabel label="Program entail">

                                            <Form.Control as="textarea" aria-label="Program entail" name="qualitative.programEntail" value={performancdDataForm.values.qualitative?.programEntail}
                                                onChange={performancdDataForm.handleChange}
                                                onBlur={performancdDataForm.handleBlur}
                                                isInvalid={performancdDataForm.touched.qualitative?.programEntail && performancdDataForm.errors.qualitative?.programEntail} />

                                        </FloatingLabel>
                                        <Form.Control.Feedback type="invalid">
                                            {performancdDataForm.touched.qualitative?.programEntail && performancdDataForm.errors.qualitative?.programEntail}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="programPartnersList">
                                        <FloatingLabel label="List Program Partners">
                                            <Form.Control as="textarea" aria-label="Program Partners List" name="qualitative.programPartnersList" value={performancdDataForm.values.qualitative?.programPartnersList}
                                                onChange={performancdDataForm.handleChange}
                                                onBlur={performancdDataForm.handleBlur}
                                                isInvalid={performancdDataForm.touched.qualitative?.programPartnersList && performancdDataForm.errors.qualitative?.programPartnersList} />
                                        </FloatingLabel>
                                        <Form.Control.Feedback type="invalid">
                                            {performancdDataForm.touched.qualitative?.programPartnersList && performancdDataForm.errors.qualitative?.programPartnersList}
                                        </Form.Control.Feedback>
                                    </Form.Group>
                                    <Form.Group as={Col} controlId="otherNotes">
                                        <FloatingLabel label="Other Notes">
                                            <Form.Control as="textarea" aria-label="Other Notes" name="qualitative.otherNotes" value={performancdDataForm.values.qualitative?.otherNotes}
                                                onChange={performancdDataForm.handleChange} />
                                        </FloatingLabel>
                                    </Form.Group>
                                </Row>
                            </Card.Body>
                        </Card>
                        <Row className="mb-0 main-content" >
                            <Card>
                                <Card.Title>Quantitative Data</Card.Title>
                                <Card.Body>
                                    <Row className="mb-0 main-content" >
                                        <Form.Group as={Col} controlId="formGridAddress2">
                                            <FloatingLabel label="Target Audiences">
                                                <Form.Select name="quantitative.targetAudiences" value={performancdDataForm.values.quantitative?.targetAudiences}
                                                    onChange={performancdDataForm.handleChange}
                                                    onBlur={performancdDataForm.handleBlur}
                                                    isInvalid={performancdDataForm.touched.quantitative?.targetAudiences && performancdDataForm.errors.quantitative?.targetAudiences} >
                                                    <option value=''>Select</option>
                                                    <option>Youth</option>
                                                    <option>Adult</option>
                                                    <option value='AllAge'>All Age</option>
                                                </Form.Select>
                                            </FloatingLabel>
                                            <Form.Control.Feedback type="invalid">
                                                {performancdDataForm.touched.quantitative?.targetAudiences && performancdDataForm.errors.quantitative?.targetAudiences}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridAddress2">
                                            <FloatingLabel label="Virtual or In-Person">
                                                <Form.Select name="quantitative.virtualOrInPerson" value={performancdDataForm.values.quantitative?.virtualOrInPerson}
                                                    // onKeyDown={handleInputChange}
                                                    onChange={performancdDataForm.handleChange}
                                                    onBlur={performancdDataForm.handleBlur}
                                                    isInvalid={performancdDataForm.touched.quantitative?.virtualOrInPerson && performancdDataForm.errors.quantitative?.virtualOrInPerson}>
                                                    <option value=''>Select</option>
                                                    <option>Hybrid</option>
                                                    <option>InPerson</option>
                                                    <option>Virtual</option>
                                                </Form.Select>
                                            </FloatingLabel>
                                            <Form.Control.Feedback type="invalid">
                                                {performancdDataForm.touched.quantitative?.virtualOrInPerson && performancdDataForm.errors.quantitative?.virtualOrInPerson}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        {isVirtual ? <Col /> : (
                                            <Form.Group as={Col} controlId="formGridAddress2">
                                                <FloatingLabel label="On-site or Off-site">
                                                    <Form.Select name="quantitative.onsiteOrOffsite" value={performancdDataForm.values.quantitative?.onsiteOrOffsite}
                                                        onChange={performancdDataForm.handleChange}
                                                        onBlur={performancdDataForm.handleBlur}
                                                        isInvalid={performancdDataForm.touched.quantitative?.onsiteOrOffsite && performancdDataForm.errors.quantitative?.onsiteOrOffsite}>
                                                        <option value=''>Select</option>
                                                        <option>OnSite</option>
                                                        <option>OffSite</option>
                                                    </Form.Select>
                                                </FloatingLabel>
                                                <Form.Control.Feedback type="invalid">
                                                    {performancdDataForm.touched.quantitative?.onsiteOrOffsite && performancdDataForm.errors.quantitative?.onsiteOrOffsite}
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        )}


                                    </Row >
                                    <Row className="mb-0 main-content">
                                        <Form.Group as={Col} controlId="formGridAddress2">
                                            <FloatingLabel label="Attendance">
                                                <Form.Control type="number" name="quantitative.attendance" value={performancdDataForm.values.quantitative?.attendance}
                                                    onChange={performancdDataForm.handleChange} onKeyDown={blockInvalidChar}
                                                    onBlur={performancdDataForm.handleBlur}
                                                    isInvalid={performancdDataForm.touched.quantitative?.attendance && performancdDataForm.errors.quantitative?.attendance} />
                                            </FloatingLabel>
                                            <Form.Control.Feedback type="invalid">
                                                {performancdDataForm.touched.quantitative?.attendance && performancdDataForm.errors.quantitative?.attendance}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="countyHeld">

                                            {isVirtual ? (<>
                                                <FloatingLabel label="Location of Attendees">
                                                    <Form.Select name="quantitative.countyHeld" value={performancdDataForm.values.quantitative?.countyHeld}
                                                        onChange={performancdDataForm.handleChange}
                                                        onBlur={performancdDataForm.handleBlur}
                                                        isInvalid={performancdDataForm.touched.quantitative?.countyHeld && performancdDataForm.errors.quantitative?.countyHeld}>
                                                        <option value=''>Select</option>
                                                        <option>Virtual-PA</option>
                                                        <option>Virtual-outside-PA</option>
                                                    </Form.Select>
                                                </FloatingLabel>
                                                <Form.Control.Feedback type="invalid">
                                                    {performancdDataForm.touched.quantitative?.countyHeld && performancdDataForm.errors.quantitative?.countyHeld}
                                                </Form.Control.Feedback>
                                            </>
                                            ) : (<>
                                                <FloatingLabel label="Location of Attendees">
                                                    <Form.Select name="quantitative.countyHeld" value={performancdDataForm.values.quantitative?.countyHeld}
                                                        onChange={performancdDataForm.handleChange}
                                                        onBlur={performancdDataForm.handleBlur}
                                                        isInvalid={performancdDataForm.touched.quantitative?.countyHeld && performancdDataForm.errors.quantitative?.countyHeld}>
                                                        <option value=''>Select</option>

                                                        <option>Adams	</option>
                                                        <option>Allegheny	</option>
                                                        <option>Armstrong	</option>
                                                        <option>Beaver	</option>
                                                        <option>Bedford	</option>
                                                        <option>Berks	</option>
                                                        <option>Blair	</option>
                                                        <option>Bradford	</option>
                                                        <option>Bucks	</option>
                                                        <option>Butler	</option>
                                                        <option>Cambria	</option>
                                                        <option>Cameron	</option>
                                                        <option>Carbon	</option>
                                                        <option>Centre	</option>
                                                        <option>Chester	</option>
                                                        <option>Clarion	</option>
                                                        <option>Clearfield	</option>
                                                        <option>Clinton	</option>
                                                        <option>Columbia	</option>
                                                        <option>Crawford	</option>
                                                        <option>Cumberland	</option>
                                                        <option>Dauphin	</option>
                                                        <option>Delaware	</option>
                                                        <option>Elk	</option>
                                                        <option>Erie	</option>
                                                        <option>Fayette	</option>
                                                        <option>Forest	</option>
                                                        <option>Franklin	</option>
                                                        <option>Fulton	</option>
                                                        <option>Greene	</option>
                                                        <option>Huntingdon	</option>
                                                        <option>Indiana	</option>
                                                        <option>Jefferson	</option>
                                                        <option>Juniata	</option>
                                                        <option>Lackawanna	</option>
                                                        <option>Lancaster	</option>
                                                        <option>Lawrence	</option>
                                                        <option>Lebanon	</option>
                                                        <option>Lehigh	</option>
                                                        <option>Luzerne	</option>
                                                        <option>Lycoming	</option>
                                                        <option>McKean	</option>
                                                        <option>Mercer	</option>
                                                        <option>Mifflin	</option>
                                                        <option>Monroe	</option>
                                                        <option>Montgomery	</option>
                                                        <option>Montour	</option>
                                                        <option>Northampton	</option>
                                                        <option>Northumberland	</option>
                                                        <option>Perry	</option>
                                                        <option>Philadelphia	</option>
                                                        <option>Pike	</option>
                                                        <option>Potter	</option>
                                                        <option>Schuylkill	</option>
                                                        <option>Snyder	</option>
                                                        <option>Somerset	</option>
                                                        <option>Sullivan	</option>
                                                        <option>Susquehanna	</option>
                                                        <option>Tioga	</option>
                                                        <option>Union	</option>
                                                        <option>Venango	</option>
                                                        <option>Warren	</option>
                                                        <option>Washington	</option>
                                                        <option>Wayne	</option>
                                                        <option>Westmoreland	</option>
                                                        <option>Wyoming	</option>
                                                        <option>York	</option>
                                                    </Form.Select>
                                                </FloatingLabel>
                                                <Form.Control.Feedback type="invalid">
                                                    {performancdDataForm.touched.quantitative?.countyHeld && performancdDataForm.errors.quantitative?.countyHeld}
                                                </Form.Control.Feedback>
                                            </>
                                            )}

                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridAddress2">
                                            <FloatingLabel label="Free or discounted opportunities">
                                                <Form.Control type="number" name="quantitative.freeOrDiscounted" value={performancdDataForm.values.quantitative?.freeOrDiscounted}
                                                    onChange={performancdDataForm.handleChange} onKeyDown={blockInvalidChar}
                                                    onBlur={performancdDataForm.handleBlur}
                                                    isInvalid={performancdDataForm.touched.quantitative?.freeOrDiscounted && performancdDataForm.errors.quantitative?.freeOrDiscounted} />
                                            </FloatingLabel>
                                            <Form.Control.Feedback type="invalid">
                                                {performancdDataForm.touched.quantitative?.freeOrDiscounted && performancdDataForm.errors.quantitative?.freeOrDiscounted}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                    </Row>
                                </Card.Body>
                            </Card>
                        </Row>

                        <Card>
                            <Card.Body>
                                <Card.Title>Fiscal</Card.Title>

                                <Row className="mb-0 main-content" >
                                    <Table bordered striped hover >
                                        <thead>
                                            <tr>
                                                <th>Revenue</th>
                                                <th>Expenses</th>
                                                <th>Proposed/Projected Budget</th>
                                                <th>Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <Form.Group as={Col} controlId="revenue">
                                                        <Form.Select defaultValue="" name="revenue" required value={fiscalForm.revenue}
                                                            onChange={fiscalForm.handleChange}
                                                            isInvalid={fiscalForm.touched.revenue && fiscalForm.errors.revenue}>
                                                            <option value="">Select</option>
                                                            <option>Sponsorships/donations</option>
                                                            <option>Admissions</option>
                                                        </Form.Select>
                                                        <Form.Control.Feedback type='invalid'>
                                                            {fiscalForm.touched.revenue && fiscalForm.errors.revenue}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </td>
                                                <td>
                                                    <Form.Group as={Col} controlId="expenses">
                                                        <Form.Select defaultValue="" name="expenses" required value={fiscalForm.expenses}
                                                            onChange={fiscalForm.handleChange}
                                                            isInvalid={fiscalForm.touched.expenses && fiscalForm.errors.expenses}>
                                                            <option value="">Select</option>
                                                            <option>Recurring</option>
                                                            <option>One-time/Periodic</option>
                                                        </Form.Select>
                                                        <Form.Control.Feedback type='invalid'>
                                                            {fiscalForm.touched.expenses && fiscalForm.errors.expenses}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </td>
                                                <td>
                                                    <Form.Group>
                                                        <Form.Control name="projectedBudget" value={fiscalForm.projectedBudget}
                                                            onChange={fiscalForm.handleChange} onKeyDown={blockInvalidChar}
                                                            isInvalid={performancdDataForm.touched.projectedBudget && fiscalForm.errors.projectedBudget} />
                                                        <Form.Control.Feedback type='invalid'>
                                                            {fiscalForm.touched.projectedBudget && fiscalForm.errors.projectedBudget}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                </td>
                                                <td><Button variant="primary" disabled={!fiscalForm.dirty} onClick={handleFiscalRecord}> +</Button></td>
                                            </tr>
                                            {
                                                performancdDataForm.values.fiscal.map((input, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td>{input.revenue}</td>
                                                            <td>{input.expenses}</td>
                                                            <td>{input.projectedBudget}</td>
                                                            <td ><Button variant="transparent" > <FaEdit /></Button>
                                                                <Button variant="transparent" > <FaTrash /></Button></td>
                                                        </tr>
                                                    )
                                                })
                                            }

                                        </tbody></Table>

                                </Row>
                            </Card.Body>
                        </Card>

                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleReset}>
                            Reset
                        </Button>
                        <Button variant="primary" onClick={handleData}>
                            Save
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
}

export default PerformanceDataModal;

